module.exports = __webpack_public_path__ + "img/home_introduction.0882f598.jpg";